/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module DnsModule
 */

import {
    IDnsGeoLocationMatch,
    MatchOperation,
} from 'generated-types';

import { DnsGeoLocationMatch } from 'object-types';
import { MessageItem } from 'ajs/modules/data-model/factories/message-item.factory';
import { SchemaService } from 'ajs/modules/core/services/schema-service/schema.service';

/**
 * @description  DnsGeoLocationMatch ConfigItem class.
 * @author Abhinesh Gour
 */
export class DnsGeoLocationMatchConfigItem extends MessageItem<IDnsGeoLocationMatch> {
    public static ajsDependencies = [
        'schemaService',
    ];

    private readonly schemaService: SchemaService;

    constructor(args = {}) {
        super({
            objectType: DnsGeoLocationMatch,
            ...args,
        });

        this.schemaService = this.getAjsDependency_('schemaService');
    }

    /**
     * Convenience method to get text label for match criteria.
     */
    public get matchCriteria(): string {
        return this.schemaService.getEnumValueLabel(
            'MatchOperation',
            this.config.match_criteria,
        );
    }

    /** @override */
    // eslint-disable-next-line no-underscore-dangle
    public get defaultConfigOverride_(): Partial<IDnsGeoLocationMatch> {
        const defaultValues = this.getAjsDependency_('defaultValues');
        const defaultConfig = defaultValues.getDefaultItemConfigByType(this.objectType) || {};

        return {
            ...defaultConfig,
            match_criteria: MatchOperation.IS_IN,
        };
    }
}
